import React from 'react'

const Footer = () => {
  return (
   <>
   <footer className="bg-black">
        <div className="container">
            <div className="row">
                <div className="col-lg-12 text-center p-2 text-white">Copyrights 2022 ALLEN Overseas. All rights reserved.
                </div>
            </div>
        </div>
    </footer>
   </>
  )
}

export default Footer
